import { useState, useEffect, useRef } from 'react';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Description from './components/Description';
import AppliancesTechnology from './components/AppliancesTechnology';
import MaterialsFinishes from './components/MaterialsFinishes';
import KeyInfo from './components/KeyInfo';
import AnimatedStats from './components/AnimatedStats';
import Amenities from './components/Amenities';
import OperatingCosts from './components/OperatingCosts';
import SecuritySafety from './components/SecuritySafety';
import AutomationControls from './components/AutomationControls';
import LocationMap from './components/LocationMap';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Gallery />
      <Description />
      <AppliancesTechnology />
      <MaterialsFinishes />
      <KeyInfo />
      <AnimatedStats />
      <Amenities />
      <OperatingCosts />
      <SecuritySafety />
      <AutomationControls />
      <LocationMap />
      <ContactSection />
      <Footer />
    </div>
  );
}
